import { createAction } from 'redux-act';

const ActionTypes = {

    // 添加节点
    updateNode: createAction('$$/routes/updateNode'),
};

export default ActionTypes;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/routes/ActionTypes.ts